// extracted by mini-css-extract-plugin
export var card = "ClientTestimonialCard-module--card--ADHF6";
export var designation = "ClientTestimonialCard-module--designation--cx+fF";
export var icon = "ClientTestimonialCard-module--icon--tbVTr";
export var img = "ClientTestimonialCard-module--img--A7jco";
export var logo = "ClientTestimonialCard-module--logo--zBEMe";
export var name = "ClientTestimonialCard-module--name--7fEjM";
export var projectDescription = "ClientTestimonialCard-module--project-description--fZZkC";
export var review = "ClientTestimonialCard-module--review--09X-M";